<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newEvent')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'booking-events' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createEvent" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <event-details-card ref="eventDetailsCard"
                              v-bind:event="event" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import EventDetailsCard from '@/components/booking/EventDetailsCard.vue'
  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'

  export default {
    components: {
      EventDetailsCard,
      HeaderButton,
      TopHeader
    },
    async created() {
      this.loadEvents()
    },
    data: () => ({
      event: {
        attendanceFee: 0
      },
      loading: false,
      validationSnackbar: false
    }),
    methods: {
      async createEvent() {
        if (!this.$refs.eventDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateEvent({ event: this.event })

        this.$router.push({ name: 'booking-event', params: { id: this.event.id } })
      },
      ...mapActions({
        doCreateEvent: 'booking/createEvent',
        loadEvents: 'booking/loadEvents'
      })
    },
    name: 'EventAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newEvent": "Neues Seminar",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newEvent": "New event",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>